import { PasswordResetRequest, PasswordResetRequestBE, UserType, UserTypeBE } from "@/types/user";

export const mapUserBEToDTO = (userBE: UserTypeBE): UserType => {
  return {
    id: userBE.id.toString(),
    created: userBE.created_at,
    updated: userBE.updated_at,
    name: userBE.name,
    email: userBE.email,
    emailVerifiedAt: userBE.email_verified_at,
    subscriberId: userBE.subscriber_id,
    intercomId: userBE.intercom_id,
    language: userBE.language,
    role: userBE.role,
  };
};

export const mapUsersBEsToDTO = (
  usersBEArray: UserTypeBE[]
): UserType[] => {
  return usersBEArray.map((userBE) => {
    return mapUserBEToDTO(userBE);
  });
};

export const mapUserDTOToBEForUpdate = (
  user: Partial<UserType>
): Partial<UserTypeBE> => {
  return {
    id: user.id ? parseInt(user.id) : undefined,
    email: user.email,
    name: user.name,
    language: user.language,
  };
};

export const mapPasswordResetRequestToBEForUpdate = (
  request: Partial<PasswordResetRequest>
): Partial<PasswordResetRequestBE> => {
  return {
    current_password: request.currentPassword,
    password: request.newPassword,
    password_confirmation: request.confirmPassword,
  };
};

// import { AuthResponse, AuthResponseBE } from '@/types/user';

// export const mapUserBEToDTO = (auth: AuthResponseBE): AuthResponse => {
//   return {
//     accessToken: auth.access_token,
//     tokenType: auth.token_type,
//     expiresIn: auth.expires_in,
//   };
// };
